import { PriceType } from '../../../types/briefing';
import { StepConfig } from '../stepHelpers/types';

export const stepConfig: StepConfig<PriceType> = {
  base: {
    applications: {
      '*': { '*': [] },
    },
  },
  color: {
    applications: {
      '*': { HomeCareIndustrialCleaning: [] },
    },
  },
  fragrance: {
    applications: {
      '*': { HomeCareIndustrialCleaning: [] },
    },
  },
};
